export default __webpack_public_path__ + "static/media/video2.f6ee6108.mp4";